/* Mutual Optical — PDP gallery: image counter (1 / N). Zoom is Dawn's hover magnify. */
(function () {
  function init() {
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (!list) return;
    var items = list.querySelectorAll('.product__media-item');
    var total = items.length;
    if (!total || document.querySelector('.mo-gallery-counter')) return;

    var counter = document.createElement('div');
    counter.className = 'mo-gallery-counter';
    list.appendChild(counter);

    function activeIdx() {
      for (var i = 0; i < items.length; i++) { if (items[i].classList.contains('is-active')) return i; }
      var c = list.scrollLeft + list.clientWidth / 2;
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        if (it.offsetLeft <= c && (it.offsetLeft + it.offsetWidth) > c) return j;
      }
      return 0;
    }
    function update() { counter.textContent = (activeIdx() + 1) + ' / ' + total; }
    update();

    var mo = new MutationObserver(update);
    for (var i = 0; i < items.length; i++) mo.observe(items[i], { attributes: true, attributeFilter: ['class'] });
    var t = null;
    list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 80); }, { passive: true });
    var thumbs = document.querySelectorAll('.product__media-wrapper .thumbnail');
    for (var k = 0; k < thumbs.length; k++) thumbs[k].addEventListener('click', function () { setTimeout(update, 130); });
  }

  /* Hover-to-zoom. Dawn's own "hover" zoom mode only magnifies after a click, so it is
     reimplemented here; the native lightbox stays for touch devices. */
  function initHoverZoom() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var ZOOM = 2.2;

    if (!document.getElementById('mo-zoom-style')) {
      var st = document.createElement('style');
      st.id = 'mo-zoom-style';
      st.textContent =
        '.product__media-wrapper .product-media-container{cursor:zoom-in;}' +
        // Hover zoom replaces the badge as the affordance here; touch devices keep it.
        '.product__media-wrapper .product__media-icon{display:none!important;}' +
        '.product__media-wrapper .product__media{position:relative;}' +
        '.mo-zoom-lens{position:absolute;z-index:4;pointer-events:none;transform-origin:0 0;max-width:none;}';
      document.head.appendChild(st);
    }

    var boxes = document.querySelectorAll('.product__media-wrapper .product-media-container');
    for (var i = 0; i < boxes.length; i++) (function (box) {
      if (box.getAttribute('data-mo-zoom')) return;
      box.setAttribute('data-mo-zoom', '1');
      var media = box.querySelector('.product__media');
      var img = box.querySelector('img');
      if (!media || !img) return;
      var lens = null;

      // Painted area of an object-fit:contain image, relative to its own box.
      function area() {
        var cw = img.clientWidth, ch = img.clientHeight;
        var nr = (img.naturalWidth || 1) / (img.naturalHeight || 1);
        var w = cw, h = cw / nr;
        if (h > ch) { h = ch; w = ch * nr; }
        return { w: w, h: h, x: (cw - w) / 2, y: (ch - h) / 2 };
      }
      function show() {
        if (lens || !img.complete || !img.naturalWidth) return;
        var a = area();
        lens = document.createElement('img');
        lens.className = 'mo-zoom-lens';
        lens.src = (img.currentSrc || img.src).replace(/([?&]width=)\d+/, '$11946');
        lens.style.left = a.x + 'px'; lens.style.top = a.y + 'px';
        lens.style.width = a.w + 'px'; lens.style.height = a.h + 'px';
        media.appendChild(lens);
      }
      function move(e) {
        if (!lens) return;
        var a = area(), b = media.getBoundingClientRect();
        var px = Math.min(Math.max((e.clientX - b.left - a.x) / a.w, 0), 1);
        var py = Math.min(Math.max((e.clientY - b.top - a.y) / a.h, 0), 1);
        lens.style.transform = 'translate(' + (-px * a.w * (ZOOM - 1)) + 'px,' +
          (-py * a.h * (ZOOM - 1)) + 'px) scale(' + ZOOM + ')';
      }
      function hide() { if (lens) { lens.parentNode && lens.parentNode.removeChild(lens); lens = null; } }

      box.addEventListener('mouseenter', show);
      box.addEventListener('mousemove', function (e) { show(); move(e); });
      box.addEventListener('mouseleave', hide);
    })(boxes[i]);
  }
  /* 加购后不展开购物车抽屉，改成右下角轻提示。
     B2B 客户会在同一个商品页反复加购，每次都把抽屉推出来会打断流程。

     **关键前提（实测）：本站的购物车抽屉没有任何用户入口。**
     Dawn 靠 `#cart-icon-bubble` 给页眉购物车图标绑定 open()（cart-drawer.js 的
     setHeaderCartIconAccessibility），而本站页眉是自建的 mo-header —— 线上商品页里
     `id="cart-icon-bubble"` 出现 **0 次**，那段绑定直接 bail；页眉图标是普通
     `<a href="/cart">`，点击是跳转。所以抽屉唯一的触发点就是"加购后自动弹出"。

     因此这里在商品页**直接让 open 永久失效**，不留时间窗口 —— 前两版都是
     "窗口内抵扣/遮蔽"的写法，只要有人在窗口之外调 open()（BSS 钩子、延迟定时器、
     其它 App）就会漏，客户因此两次反馈"侧边栏还是弹出来"。再加一道 MutationObserver
     兜住"直接改 class 而不走 open()"的调用者。想恢复抽屉，删掉下面覆盖 open 的那行即可。
     只在商品页生效（本文件全站加载，故此处自行判断）。 */

  /* 结果兜底：只要抽屉出现 active 就立刻关掉，不管是谁弄的（永久生效，每个实例装一次） */
  function keepDrawerClosed(cd) {
    if (!cd || cd.__moGuard) return;
    cd.__moGuard = true;
    var force = function () {
      if (!cd.classList.contains('active')) return;
      cd.classList.remove('active', 'animate');
      document.body.classList.remove('overflow-hidden');
      try { cd.close(); } catch (e) {}
    };
    new MutationObserver(force).observe(cd, { attributes: true, attributeFilter: ['class'] });
    force();
  }

  function initQuietAdd() {
    if (!document.querySelector('.product product-form, .product form[action*="/cart/add"]')) return;
    if (!window.customElements) return;

    /* ⚠️ 不能在这里直接 customElements.get('cart-drawer')。本文件与 cart-drawer.js 都是
       defer 脚本，defer 执行期间 document.readyState 已经是 'interactive' 而不是 'loading'，
       所以下面的 boot() 会立即跑；而 cart-drawer.js 在 theme.liquid 里排在本文件之后
       （300 行 vs 423 行），那时自定义元素还没注册，get() 返回 undefined，补丁会静默失效。
       改用 whenDefined 等它注册完。若 cart_type 不是 drawer，这个 promise 永远不 resolve，无副作用。 */
    customElements.whenDefined('cart-drawer').then(function () {
      var CD = customElements.get('cart-drawer');
      if (!CD || CD.__moQuietAdd) return;
      CD.__moQuietAdd = true;

      var origRender = CD.prototype.renderContents;

      // ① 抑制来源：商品页上 open 永久失效（本站没有别的入口，见上方说明）
      CD.prototype.open = function () {};

      // ② 结果兜底：现在就装上，不等第一次加购
      keepDrawerClosed(document.querySelector('cart-drawer'));

      CD.prototype.renderContents = function (state) {
        keepDrawerClosed(this);
        origRender.call(this, state);
        toast(state);
      };
    });
  }

  var toastTimer = null;
  function toast(state) {
    if (!document.getElementById('mo-toast-style')) {
      var st = document.createElement('style');
      st.id = 'mo-toast-style';
      st.textContent =
        // bottom 用 86px 而不是 20px：右下角已被 Avada FAQ 挂件占用
        // （div.Avada-Faqs_Button，58×56，right 15 / bottom 15，z-index 999999），
        // 贴在 20px 会和它叠在一起，且它的层级更高会压住 toast。
        '.mo-toast{position:fixed;right:20px;bottom:86px;z-index:1000;display:flex;gap:12px;' +
          'align-items:center;box-sizing:border-box;max-width:360px;padding:14px 16px;border-radius:12px;' +
          'background:#fff;border:1px solid #ece7dd;box-shadow:0 12px 32px rgba(11,35,67,.16);' +
          'opacity:0;transform:translateY(12px);transition:opacity .22s ease,transform .22s ease;' +
          'pointer-events:none;}' +
        '.mo-toast.is-in{opacity:1;transform:none;pointer-events:auto;}' +
        '.mo-toast__ico{flex:0 0 auto;width:26px;height:26px;border-radius:50%;background:#16a05d;' +
          'color:#fff;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:700;}' +
        '.mo-toast__tx{min-width:0;}' +
        '.mo-toast__t{margin:0;font-size:13px;font-weight:700;color:#0b2343;}' +
        '.mo-toast__s{margin:2px 0 0;font-size:12.5px;color:#6b6358;overflow:hidden;' +
          'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}' +
        '.mo-toast__link{margin-left:auto;flex:0 0 auto;font-size:12px;font-weight:700;' +
          'text-transform:uppercase;letter-spacing:.04em;color:#c89b3c;text-decoration:none;white-space:nowrap;}' +
        '.mo-toast__link:hover{text-decoration:underline;}' +
        '@media (max-width:749px){.mo-toast{left:12px;right:12px;bottom:84px;max-width:none;}}' +
        '@media (prefers-reduced-motion:reduce){.mo-toast{transition:none;}}';
      document.head.appendChild(st);
    }

    var el = document.getElementById('mo-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mo-toast';
      el.className = 'mo-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }

    /* 只显示名称与件数，不显示任何金额 */
    var line = (state && state.items && state.items[0]) || state || {};
    var name = line.product_title || line.title || '';
    if (line.variant_title && line.product_title) name += ' — ' + line.variant_title;
    name = String(name).replace(/\s*[-—]\s*Default Title$/i, '');
    var qty = Number(line.quantity) || 0;
    var sub = (qty > 1 ? qty + ' × ' : '') + name;

    el.innerHTML =
      '<span class="mo-toast__ico" aria-hidden="true">&#10003;</span>' +
      '<div class="mo-toast__tx"><p class="mo-toast__t">Added to cart</p>' +
        (name ? '<p class="mo-toast__s"></p>' : '') + '</div>' +
      '<a class="mo-toast__link" href="' + (window.routes && routes.cart_url ? routes.cart_url : '/cart') + '">View cart</a>';
    if (name) el.querySelector('.mo-toast__s').textContent = sub;   // textContent 避免注入

    requestAnimationFrame(function () { el.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-in');
    }, 2000);
  }

  function boot() { init(); initHoverZoom(); initQuietAdd(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
